import { Vue } from 'vue-property-decorator';

export default class VueExtension extends Vue {
    declare $store: any;
}
